import { useState } from "react";

import { useParams } from "react-router-dom";
import HrmOvertimeTable from "../../components/hrm/HrmOvertimeTable";
import { IOvertimeRequestQuery } from "../../models/Hrm";
import { useGetOvertimeByEmployee } from "../../query/HrmQuery";
import NotFound from "../NotFound/NotFound";

export const HrmOvertimeEmployee = () => {
  const { alias } = useParams<{ alias: string }>();
  const [filter, setFilter] = useState<IOvertimeRequestQuery>({
    page: 1,
    limit: 10,
  });
  const { data, isLoading } = useGetOvertimeByEmployee(alias!, filter);

  if (!alias) return <NotFound />;

  return (
    <HrmOvertimeTable
      data={data!}
      isLoading={isLoading}
      filter={filter}
      setFilter={setFilter}
    />
  );
};
